module.exports = __webpack_public_path__ + "img/catalog.37bcd4d0.jpg";